export default __webpack_public_path__ + "static/media/LouisP.2e63778c.jpeg";